<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M8.00084 15.4284C12.1036 15.4284 15.4294 12.1026 15.4294 7.99986C15.4294 3.89717 12.1036 0.571289 8.00084 0.571289C3.89815 0.571289 0.572266 3.89717 0.572266 7.99986C0.572266 12.1026 3.89815 15.4284 8.00084 15.4284Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.5625 6.50159C9.74125 6.21111 10.1345 6.0249 10.5159 6.0249C10.8972 6.0249 11.2905 6.21111 11.4693 6.50159"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M6.43798 6.50159C6.25923 6.21111 5.86596 6.0249 5.48461 6.0249C5.10327 6.0249 4.71 6.21111 4.53125 6.50159"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4.77734 9.86768C4.77734 10.7576 5.49875 11.479 6.38866 11.479C7.27855 11.479 7.99996 10.7576 7.99996 9.86768C7.99996 10.7576 8.72138 11.479 9.61127 11.479C10.5012 11.479 11.2226 10.7576 11.2226 9.86768"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
